module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cy-385433a809dac269feac09fac938c2a7.svg";